export function isBoolean(value: any): boolean {
  return 'boolean' == typeof value;
}
